import { useCallback } from "react";
import type {
  LoadingStage,
  LoadingStatus
} from "../components/Shared/Modals/LoadingStatusModal/LoadingStatusModal";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  loadingReset,
  selectIsLoading,
  stageUpdated
} from "../store/slices/loadingSlice";

export const useLoadingStatus = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsLoading);

  const updateStage = useCallback(
    (
      stage: LoadingStage,
      status: LoadingStatus,
      error?: { message: string; technicalDetails?: string }
    ) => {
      dispatch(stageUpdated({ stage, status, error }));
    },
    [dispatch]
  );
  const resetLoading = useCallback(() => {
    dispatch(loadingReset());
  }, [dispatch]);

  return { updateStage, resetLoading, isLoading };
};
